import { apiRequest } from "./client";
import { normalizeListPayload } from "../utils/pagination";

const toQuery = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") search.set(key, value);
  });
  const value = search.toString();
  return value ? `?${value}` : "";
};

export const fetchEnquiries = async (params = {}) => {
  const payload = await apiRequest(
    `/enquiries${toQuery({
      page: 1,
      per_page: 20,
      sort_by: "created_at",
      sort_order: "desc",
      ...params,
    })}`
  );
  const { items: enquiries, meta } = normalizeListPayload(payload, {
    itemKeys: ["enquiries"],
    perPage: params.per_page,
  });
  const body = payload?.data && !Array.isArray(payload.data) ? payload.data : payload;

  const summary = body?.summary || {
    total: meta.total,
    new: enquiries.filter((item) => item.status === "new").length,
    in_progress: enquiries.filter((item) => item.status === "in_progress").length,
    closed: enquiries.filter((item) => item.status === "closed").length,
  };

  return { enquiries, meta, summary };
};

export const fetchEnquiry = async (id) => {
  const payload = await apiRequest(`/enquiries/${id}`);
  return payload?.data ?? payload;
};

export const updateEnquiryStatus = async (id, status) => {
  const payload = await apiRequest(`/enquiries/${id}/status`, {
    method: "PUT",
    body: JSON.stringify({ status }),
  });
  return payload?.data ?? payload;
};
